<div class="position-relative h-100 d-flex flex-column">
  <app-section-loader [loading]="loading"></app-section-loader>
  <div class="scroll page-bg flex-fill overflow-auto py-3 px-5 centerform" *ngIf="!loading">
    <div class="container p-0">
      <div class="mControls">
        <div class="input-group mr-auto">
          <h1 class="m-0 text-white align-items-center d-inline-flex">
            {{ "Lesson " + lesson?.lesson_plan_number + " Guide" }}
          </h1>
        </div>
        <div class="mControls__right">
          <div *ngIf="loggedInUser !== tutorRoleId">
            <div class="input-group">
              <button mat-raised-button color="warn" (click)="deleteLesson()">
                <mat-icon>block</mat-icon> Delete lesson
              </button>
            </div>
          </div>
          <div class="input-group">
            <button mat-raised-button (click)="navigateBack()">
              <mat-icon>done</mat-icon> Done
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mb-3">
          <div class="card">
            <div class="card-header">General</div>
            <div class="card-body">
              <ul class="list-unstyled form-lr">
                <li>
                  <span class="form-lr__left">Lesson Plan Name:</span>
                  <span class="form-lr__right">{{ lesson?.lesson_plan_name }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Lesson Plan Number:</span>
                  <span class="form-lr__right">{{ lesson?.lesson_plan_number }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Grade Level:</span>
                  <span class="form-lr__right">{{ lesson?.grade_id?.grade_level }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Yearly Plans:</span>
                  <span class="form-lr__right">{{ lesson?.curriculum_names?.length ? lesson.curriculum_names.join(', ') : '—' }}</span>
                </li>
              </ul>
              <ul class="list-unstyled form-lr mt-4">
                <li>
                  <span class="form-lr__left">Tutor Tips</span>
                  <div [innerHTML]="lesson?.summary | safeHtml" class="form-lr__right"></div>
                </li>
                <li>
                  <span class="form-lr__left">Be The Difference:</span>
                  <span class="form-lr__right">{{ lesson?.be_the_difference }}</span>
                </li>
                <li>
                  <span class="form-lr__left">UFLI Strategies:</span>
                  <span class="form-lr__right">{{ lesson?.ufli_strategies || '' }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Easy Read:</span>
                  <span class="form-lr__right">{{ lesson?.easy_read }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Read With:</span>
                  <span class="form-lr__right">{{ lesson?.read_with }}</span>
                </li>
              </ul>
            </div>
          </div>

          <div class="card mt-4 mb-4">
          <div *ngFor="let passage of lesson.passage; let i = index" class="passage">
            <div class="card-header">Lesson Passage {{ i + 1 }}</div>
            <div class="card-body">
              <ul class="list-unstyled form-lr">
                <li>
                  <span class="form-lr__left">Passage Name:</span>
                  <span class="form-lr__right">{{ passage.passage_name }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Total Word Count:</span>
                  <span class="form-lr__right">{{ passage?.word_count }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Summary</span>
                  <div [innerHTML]="passage?.summary | safeHtml" class="form-lr__right"></div>
                </li>
                </ul>
                <div class="mt-4 hug_sliderimage">
  <img
    *ngIf="images[i]?.length"
    [src]="images[i][0]"
    style="width: 100%; height: 400px; object-fit: contain;"
    alt="image"
  />
</div>

            </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div
    class="flex-fill d-flex flex-column align-items-center justify-content-center"
    *ngIf="loading"
  >
    <img src="assets/images/no-result.png" alt="" />
  </div>
</div>
